/* ── Cart Cross-Sell – Add to cart + dots navigation ── */
(function () {
  /* ── Dots / IntersectionObserver ── */
  function initDots(container) {
    var slider = container.querySelector('[data-cross-sell-slider]');
    var dotsWrap = container.querySelector('[data-cross-sell-dots]');
    var cards = slider ? slider.querySelectorAll('[data-cross-sell-card]') : [];
    if (!dotsWrap || cards.length < 3) return;

    // Build dot elements
    cards.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'cart-cross-sell__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', function () {
        cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = dotsWrap.querySelectorAll('.cart-cross-sell__dot');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = Array.prototype.indexOf.call(cards, entry.target);
            dots.forEach(function (d, j) {
              d.classList.toggle('is-active', j === idx);
            });
          }
        });
      },
      { root: slider, threshold: 0.6 }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  /* ── Add to cart (check existing items first) ── */
  function handleAdd(btn) {
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    btn.classList.add('is-loading');

    // 1. Fetch current cart to check if variant already exists
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var existing = cart.items.find(function (item) {
          return item.variant_id === variantId;
        });

        if (existing) {
          // Variant already in cart → increment quantity via /cart/change.js
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existing.key, quantity: existing.quantity + 1 }),
          });
        } else {
          // New variant → add via /cart/add.js
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });
        }
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');

        // Analytics event
        window.dataLayer = window.dataLayer || [];
        // Reset avant le push : sinon GTM relit les items de l'événement précédent
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'add_to_cart_cross_sell',
          ecommerce: {
            currency: 'EUR',
            value: parseFloat(btn.dataset.price) || 0,
            items: [{
              item_id: variantId,
              item_name: btn.dataset.productTitle || '',
              item_variant: btn.dataset.variantTitle || '',
              item_brand: btn.dataset.vendor || '',
              price: parseFloat(btn.dataset.price) || 0,
              quantity: 1,
            }]
          }
        });

        // Publish cart update event (pubsub.js pattern)
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {});
        }

        // Re-render cart drawer via section rendering API
        refreshCartDrawer();

        // Reset button after 2s
        setTimeout(function () {
          btn.classList.remove('is-added');
        }, 2000);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        console.error('Cross-sell add error:', err);
      });
  }

  function refreshCartDrawer() {
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        // Update cart icon bubble
        var bubbleHtml = sections['cart-icon-bubble'];
        if (bubbleHtml) {
          var bubbleEl = document.getElementById('cart-icon-bubble');
          if (bubbleEl) {
            var parser = new DOMParser();
            bubbleEl.innerHTML = parser
              .parseFromString(bubbleHtml, 'text/html')
              .querySelector('.shopify-section').innerHTML;
          }
        }

        // Update cart drawer inner content
        var drawerHtml = sections['cart-drawer'];
        if (drawerHtml) {
          var drawerEl = document.getElementById('CartDrawer');
          if (drawerEl) {
            var parser = new DOMParser();
            var newDrawer = parser.parseFromString(drawerHtml, 'text/html').getElementById('CartDrawer');
            if (newDrawer) {
              drawerEl.innerHTML = newDrawer.innerHTML;
              // Re-init cross-sell in new DOM
              initAll();
            }
          }
        }
      })
      .catch(function (err) {
        console.error('Cart drawer refresh error:', err);
      });
  }

  /* ── Delegated click ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-cross-sell__add');
    if (btn && !btn.classList.contains('is-loading') && !btn.classList.contains('is-added')) {
      e.preventDefault();
      handleAdd(btn);
    }
  });

  /* ── Init all cross-sell blocks ── */
  function initAll() {
    document.querySelectorAll('[data-cross-sell]').forEach(function (container) {
      var dotsWrap = container.querySelector('[data-cross-sell-dots]');
      if (dotsWrap && dotsWrap.children.length === 0) {
        initDots(container);
      }
    });
  }

  // Init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
